export const _90_DAY_CARE_PLAN = "90_day_care_plan";

export const PAYMENT_TAB = "Payment";
